import {
  IAdvancedRulesClient,
  IFieldsMap,
  IForm,
  IFieldsToHIdeAndShow,
  IPageToHIdeAndShow,
  IFormLevelRuleConditionMap,
  IModalData,
  submisionType,
  IFieldLoaderMap,
  ICompositeKeyFields,
} from "@common/redux/formBuilder/interface";
import { IPageLevelRuleClient } from "@presentation/FormBuilder/components/ConfiguredRule/interface";
import { ruleInitialStateClient } from "./utils";
import {
  IFieldLevelRuleClient,
  IFieldLevelRuleConditionMap,
  IFormLevelRuleClient,
  IPageLevelRuleConditionMap,
  IRulesMap,
  ISubmissionLevelRuleClient,
  ISubmissionLevelRuleConditionMap,
} from "@common/redux/forms/interface";
import { FormModes } from "@presentation/FormBuilder/components/DescriptionField/utils";
export const getActiveFormDataSelector = (state: any): IForm => {
  return state?.formbuilder?.activeForm || {};
};
export const getUpdatedFormMode = (state: any): FormModes => {
  return state?.formbuilder?.formMode || FormModes.view;
};
export const getActiveFormIdSelector = (state: any): string => {
  return (
    state?.formbuilder?.activeForm?.id ||
    state?.formbuilder?.activeForm?.localId ||
    {}
  );
};

export const getFieldsMapOfActiveFormSelector = (state: any): IFieldsMap => {
  return state?.formbuilder?.activeForm?.fieldsMap || {};
};
export const getFieldLoaderMapSelector = (state: any): IFieldLoaderMap => {
  return state?.formbuilder?.fieldLoaderMap || {};
};
export const getCurrentEditModeFieldIdSelector = (state: any): string => {
  return state?.formbuilder?.currentEditModeFieldId || "";
};

export const getCurrentFocusedFieldIdSelector = (state: any): string => {
  return state?.formbuilder?.currentFocusedFieldId || "";
};

export const getFieldIdsOfPerticularFormSelector = (
  state: any,
  formId: string
): string[] => {
  const overviewForm = state?.formbuilder?.activeForm?.overviewForm || [];
  const fieldsMap = state?.formbuilder?.activeForm?.fieldsMap || {};
  const subFormsMap = state?.formbuilder?.activeForm?.subFormsMap || {};

  if (subFormsMap[formId]) {
    return subFormsMap[formId]?.fields || [];
  } else if (fieldsMap[formId]) {
    return fieldsMap[formId]?.fields || [];
  } else {
    return overviewForm || [];
  }
};

export const getActiveFieldRulesSelector = (
  state: any
): IFieldLevelRuleClient[] => {
  return state?.formbuilder?.activeRules?.fieldRules || [];
};

export const getActivePageRulesSelector = (
  state: any
): IPageLevelRuleClient[] => {
  return state?.formbuilder?.activeRules?.pageRules || [];
};

export const fetchRulesPopupDataSelector = (state: any): IModalData => {
  return state?.formbuilder?.activeRules?.modalData || {};
};

export const getActiveFormRulesSelector = (
  state: any
): IFormLevelRuleClient[] => {
  return state?.formbuilder?.activeRules?.formRules || [];
};
export const getActiveSubmissionRulesSelector = (
  state: any
): ISubmissionLevelRuleClient[] => {
  return state?.formbuilder?.activeRules?.submissionRules || [];
};

export const getActiveRulesSelector = (state: any): IAdvancedRulesClient => {
  return state?.formbuilder?.activeRules || ruleInitialStateClient;
};

export const getFieldConditionMapSelector = (
  state: any
): IFieldLevelRuleConditionMap => {
  return state?.formbuilder?.activeRules?.fieldConditionMap ?? {};
};
export const getPageConditionMapSelector = (
  state: any
): IPageLevelRuleConditionMap => {
  return state?.formbuilder?.activeRules?.pageConditionMap ?? {};
};

export const getFormConditionMapSelector = (
  state: any
): IFormLevelRuleConditionMap => {
  return state?.formbuilder?.activeRules?.formConditionMap ?? {};
};
export const getSubmissionConditionMapSelector = (
  state: any
): ISubmissionLevelRuleConditionMap => {
  return state?.formbuilder?.activeRules?.submissionConditionMap ?? {};
};
export const getFieldsToIgnoreSelector = (state: any): string[] => {
  return state?.formbuilder?.activeRules?.fieldsToIgnore ?? [];
};

export const getFieldsToShowAndHideSelector = (
  state: any
): IFieldsToHIdeAndShow => {
  return state?.formbuilder?.activeRules?.fieldsToHideAndShow ?? { hide: [], show: [] };
};

export const getPageToShowAndHideSelector = (
  state: any
): IPageToHIdeAndShow => {
  return state?.formbuilder?.activeRules?.pageToHideAndShow ?? { show: [], hide: [], skip: [], elseSkip: [], disabled: [] };
};

export const getActiveFieldRuleIndexSelector = (state: any): number => {
  return state?.formbuilder?.activeRules?.activeFieldRuleIndex ?? 0;
};

export const getActiveSubFormIndexSelector = (state: any): number => {
  return state?.formbuilder?.activeSubformIndex ?? 0;
};

export const getActiveRuleSelector = (state: any): IAdvancedRulesClient => {
  return state?.formbuilder?.activeRules;
};

export const getActiveSubmissionType = (state: any): submisionType => {
  return state?.formbuilder?.submissionType || "";
};

export const getCompositeKeyField = (state: any): string[] => {
  return state?.formbuilder?.activeForm?.compositeKeyFields || [];
};

export const getUpdatedHiddenFields = (state: any): string => {
  return state?.formbuilder?.updatedHiddenFields || [];
};

export const getSignatureResponseSelector = (state: any): string => {
  return state?.signature?.response || "";
};

export const getFormLockData = (state: any): string => {
  return state?.formbuilder?.formLockData || {};
};
